export enum MarketEnum {
  BOVESPA = 1,
  DOW_JONES = 2,
  BMF = 3,
  INDICES = 4,
  MONEY = 5,
  SOMA = 6,
  FOREX = 7,
  INDICATORS = 8,
  OTHERS = 9,
  NYSE = 10,
  BATS = 11,
  NASDAQ = 12,
  BVL = 14,
  SPINDEXES = 15,
  LIFFE = 16,
  EURONEXT_INDICES = 17,
  CME = 18,
  CME_MINI = 19,
  BITCOIN = 30
}
